<template>
  <div class="main-slide-with-cta">
    <main-slide-image-slot
      :img_src="get_img_src"
      :lazy_img_src="get_lazy_img_src"/>
    <div
      class="container main-slide-with-cta__container"
      :class="slide_height_min_height">
      <div class="main-slide-with-cta__content">
        <default-title
          v-if="title"
          white
          pre_wrap
          :title="title"
          :title_tag="title_tag"
          :upper_case="title_uppercase"/>
        <p
          v-if="sub_title"
          class="main-slide-with-cta__sub-title">{{ sub_title }}</p>
        <default-button
          v-if="button_text"
          :href="button_link"
          class="main-slide-with-cta__button">
          {{ button_text }}
        </default-button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import MainSlideImageSlot from "../slots/MainSlideImageSlot.vue";
import DefaultTitle from "../small_parts/DefaultTitle.vue";
import DefaultButton from "../slots/DefaultButton.vue";

export default {
  name: "MainSlideWithCta",
  components: {
    DefaultButton,
    DefaultTitle,
    MainSlideImageSlot
  },
  props: {
    /**props**/
    img_src: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    lazy_img_src: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    img_src_mobile: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    lazy_img_src_mobile: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    title: {
      type: String,
      default: '',
      admin_type: 'textarea',
    },
    title_tag: {
      type: String,
      default: 'h1',
      admin_type: 'select',
      admin_data_values: [
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
      ],
    },
    title_uppercase: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    sub_title: {
      type: String,
      default: '',
      admin_type: 'textarea',
    },
    button_text: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    button_link: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    slide_height_min_height: {
      type: String,
      default: '',
      admin_type: 'select',
      allow_deselect: true,
      admin_data_values: [
        'min_height-300',
        'min_height-350',
        'min_height-500'
      ],
    },
    /**props**/
  },
  computed: {
    ...mapGetters([
      'getIsMobile'
    ]),
    get_img_src() {
      if (!this.getIsMobile) return this.img_src
      return this.img_src_mobile ? this.img_src_mobile : this.img_src
    },
    get_lazy_img_src() {
      if (!this.getIsMobile) return this.lazy_img_src
      return this.lazy_img_src_mobile ? this.lazy_img_src_mobile : this.lazy_img_src
    },
  }
}
</script>
